import { SelectionStatus } from '@mitsubishi/shared/data-access';

export enum ExportSelectionUnitsEnum {
  ALL = 'ALL',
  SPECIAL_UNITS = 'SPECIAL_UNITS',
  SPECIAL_ACCESSORIES = 'SPECIAL_ACCESSORIES',
}

export interface ExportProjectsDataRequest {
  organizationId: number;
  selectionStatuses: SelectionStatus[];
  selectionCreationDateFrom: string | null;
  selectionCreationDateTo: string | null;
  selectionLastRevisionDateFrom: string | null;
  selectionLastRevisionDateTo: string | null;
  sapFamilyCodes: string[];
  unitType: ExportSelectionUnitsEnum;
  families: number[];
  classes: number[];
  subClasses: number[];
  subfamilies: number[];
}

export type ExportSelectionHistoryFamily = { familyId: number; familyCode: string };
export type ExportSelectionHistorySubFamily = { subfamilyId: number; subfamilyCode: string };

export interface ExportSelectionHistory {
  createdBy: number;
  createdAt: number;
  organizationId: number;
  selectionStatuses: SelectionStatus[];
  selectionCreationDateFrom: number;
  selectionCreationDateTo: number;
  selectionLastRevisionDateFrom: number | null;
  selectionLastRevisionDateTo: number | null;
  sapFamilyCodes: string[];
  unitType: ExportSelectionUnitsEnum;
  classes: number[];
  subClasses: number[];
  subfamilies: ExportSelectionHistorySubFamily[];
  families: ExportSelectionHistoryFamily[];
}
